<script setup lang="ts">
import { computed } from 'vue'
import { useField } from 'vee-validate'
import InputNumber from 'primevue/inputnumber'

const props = defineProps<{
  modelValue?: any
  inputName: string
  disabled?: boolean
}>()

const emit = defineEmits(['update:modelValue'])

const { value, errorMessage } = useField<number>(props.inputName)

const computedValue = computed({
  get: () => props.modelValue || '',
  set: (newVal: number) => {
    value.value = newVal
    emit('update:modelValue', newVal)
  }
})
</script>

<template>
  <div class="flex flex-col gap-2">
    <label for="weight">Weight:</label>
    <InputNumber
      id="weight"
      :disabled="disabled"
      :invalid="!!errorMessage"
      v-model="computedValue"
      model="decimal"
      :min-fraction-digits="0"
      :max-fraction-digits="5"
    />
  </div>
</template>

<style scoped></style>
